import { Outlet, createFileRoute } from "@tanstack/react-router";

import MarketingShell from "@/components/marketing/MarketingShell";

/**
 * The academy's hub surface, a sibling of `_app` for the same reason `blog` and
 * `academy-article` are: these pages are public and `_app` would guard them.
 *
 * No chrome of its own. The published hub has no footer at all, and its
 * wordmark, search field and "Go to Main Website" button sit inside the page's
 * own two columns rather than in a bar above them.
 */
export const Route = createFileRoute("/academy")({
  component: AcademyLayout,
});

function AcademyLayout() {
  return (
    <MarketingShell>
      <Outlet />
    </MarketingShell>
  );
}
